import React from "react";
import { Facebook, Twitter, Instagram, Phone, Mail } from "lucide-react";
import "../Styles/Footer.css";
import logoImg from "../assets/latest-logo.jpeg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Everything on ONE ROW */}
        <div className="footer-row">

          {/* Logo */}
          <div className="footer-logo">
            <img src={logoImg} alt="Golden Stays Logo" className="logo-image" />
            {/* <span>Golden Stays</span> */}
          </div>

          {/* Links */}
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms">Terms & Conditions</a>
          {/* <a href="/about">About Us</a>
          <a href="/cookies">Cookie Preferences</a> */}

          {/* Brand text */}
          {/* <span className="footer-text">Golden Stays</span> */}

          {/* Phone */}
          <div className="footer-inline-contact">
            <Phone size={18} className="contact-icon" />
            <a href="tel:+971558383616">+971 55 838 3616</a>
          </div>

          {/* Email */}
          <div className="footer-inline-contact">
            <Mail size={18} className="contact-icon" />
            <a href="mailto:goldenstays.airbnb@gmail.com">
              nwaego@wegohomes.co.uk
            </a>
          </div>
        </div>

        {/* Social icons directly under phone/email */}
        <div className="footer-socials">
          <a href="#" className="social-icon"><Facebook size={20} /></a>
          <a href="#" className="social-icon"><Twitter size={20} /></a>
          <a href="#" className="social-icon"><Instagram size={20} /></a>
        </div>

      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Golden Stays. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
